<template>
  <div class="ua-page">
    <div class="ua-card">
      <div class="ua-header">
        <div class="ua-icon-wrap">
          <svg class="ua-icon" viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="#4c7dff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="2" y="4" width="20" height="14" rx="2" />
            <path d="M8 21h8M12 18v3" />
          </svg>
        </div>
        <h2 class="ua-title">浏览器 User-Agent 信息</h2>
        <p class="ua-desc">以下是当前访问设备的 User-Agent 字符串，可复制后发送给技术支持以便排查问题</p>
      </div>

      <div class="ua-textarea-wrap">
        <textarea
          ref="uaTextarea"
          class="ua-textarea"
          :value="userAgent"
          readonly
          spellcheck="false"
        ></textarea>
        <button class="ua-copy-btn" :class="{ copied: copied }" @click="copyUA">
          {{ copied ? "已复制" : "复制" }}
        </button>
      </div>

      <div class="ua-tip">User-Agent 包含浏览器、操作系统等信息，请放心发送给需要的人</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserAgent",
  data() {
    return {
      userAgent: "",
      copied: false
    };
  },
  mounted() {
    this.userAgent = navigator.userAgent || "";
  },
  methods: {
    copyUA() {
      const text = this.userAgent;
      if (!text) return;

      const done = () => {
        this.copied = true;
        setTimeout(() => {
          this.copied = false;
        }, 1500);
      };

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(text)
          .then(done)
          .catch(() => this.fallbackCopy(text, done));
      } else {
        this.fallbackCopy(text, done);
      }
    },
    fallbackCopy(text, done) {
      const textarea = this.$refs.uaTextarea;
      textarea.removeAttribute("readonly");
      textarea.select();
      textarea.setSelectionRange(0, text.length);
      let ok = false;
      try {
        ok = document.execCommand("copy");
      } catch (e) {
        ok = false;
      }
      textarea.setAttribute("readonly", "readonly");
      if (ok) {
        done();
      }
    }
  }
};
</script>

<style scoped>
.ua-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e9f2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 20px;
}

.ua-card {
  background: #fff;
  border-radius: 16px;
  padding: 36px 32px 28px;
  max-width: 640px;
  width: 100%;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

.ua-header {
  text-align: center;
  margin-bottom: 24px;
}

.ua-icon-wrap {
  width: 56px;
  height: 56px;
  margin: 0 auto 14px;
  background: #eef2ff;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ua-title {
  font-size: 20px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 8px;
}

.ua-desc {
  font-size: 13px;
  color: #888;
  line-height: 1.6;
  margin: 0;
}

.ua-textarea-wrap {
  position: relative;
}

.ua-textarea {
  width: 100%;
  height: 96px;
  box-sizing: border-box;
  resize: none;
  border: 1px solid #e3e8f0;
  border-radius: 10px;
  background: #f8f9fc;
  color: #333;
  font-size: 12px;
  line-height: 1.7;
  padding: 14px 92px 14px 14px;
  word-break: break-all;
  outline: none;
}

.ua-copy-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  border: none;
  border-radius: 8px;
  background: #4c7dff;
  color: #fff;
  font-size: 13px;
  padding: 8px 16px;
  cursor: pointer;
  transition: background 0.2s;
}

.ua-copy-btn:hover {
  background: #3a6af0;
}

.ua-copy-btn.copied {
  background: #4caf50;
}

.ua-tip {
  margin-top: 14px;
  font-size: 12px;
  color: #aaa;
  text-align: center;
}
</style>
